import './TheFirstTake.css';
import TubeMain from './TubeMain';

export default function TheFirstTake() {
  document.title = 'TFT';

  return (<div className='tft'>

    <TubeMain tracksUrl='https://yt.ikura.tokyo/api/files/tft.json' />

    <div className='footer'>
      <span className='title' title='Talk Fuuinn Thefirsttake'>TFT</span>
    </div>

  </div>);
}